import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: '[app-border]',
    templateUrl: './border.component.html',
    styleUrl: './border.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BorderComponent {

}
